import { render } from "./PassCard.vue?vue&type=template&id=4c92ac84"
import script from "./PassCard.vue?vue&type=script&lang=js"
export * from "./PassCard.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__